module.exports = __webpack_public_path__ + "h5/img/bojin_bg.92c271f2.png";